import { Typography, Card, CardContent } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { numberFormat } from 'helpers/i18n';

const useStyles = makeStyles({
    amount: {
        fontWeight: '600!important'
    },
    card: {
        backgroundColor: 'white!important',
        minWidth: '280px',
        marginTop: 20
    }
});

export default function Amount({ amount }) {
    const classes = useStyles();

    return (
        <Card className={classes.card}>
            <CardContent>
                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                    TOTAL AMOUNT SPENT
                </Typography>
                <Typography variant="h6" component="div">
                    {numberFormat(amount, 2, 2)}
                </Typography>
            </CardContent>
        </Card>
    );
}
